import React from 'react';
import { useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { useTheme } from "@mui/material";
import { AppContext } from '/@/app/AppContext';
import { ScrollContext } from '/@/app/AppLayout';
import { Container, Box, Divider, Link, Typography, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { StepInfoBlock } from '/@/app/components/StepInfoBlock';
import { NextStepButton } from '/@/app/components/UserFlow/NextStepButton';


export const LabsView = () =>
{
const { t,i18n } = useTranslation();
const theme = useTheme();
const { help } = useContext(AppContext).bootstrapData;

let panels=[];
for (let k of Object.keys(help.texts).filter(k=>k.startsWith('labs-panel-') &&  k.endsWith('-'+i18n.language)).sort())
{
	const p=k.split('-',3).join('-');
	const s=k.slice(p.length+1,-3)||'caption';
	if (panels[panels.length-1]?.p!=p) panels.push({'p':p});
	panels[panels.length-1][s]=help.texts[k];
};

const {restoreScroll}=useContext(ScrollContext);
restoreScroll();

    return (
        <Container maxWidth="md" sx={{ mb: 10 }}>
            <Typography variant="h4" gutterBottom>{t('Сделайте обследование "Тераностика старения" в медицинском центре')}:</Typography>
            <Typography
                variant="h5"
                gutterBottom
                sx={{ color: theme.palette.primary.main }}
            >{t("ДНКОМ или AquaLab")}</Typography>
            <List>
                {panels.map((panel, index) => (
                    <ListItem key={index} sx={{ pt: 0, pb: 0 }}>
                        <ListItemButton component={Link} target="_blank" to={panel.link}>
                            <Box sx={{
                                width: "15px",
                                height: "15px",
                                background: 'linear-gradient(120deg, #9d59f1 30%, #835cec 90%)',
                                borderRadius: "50%",
                                mr: 1.5,
                                flexShrink: 0,
                            }}></Box>
                            <ListItemText
                                primary={panel.caption}
                                // secondary="ул. Ленина, 1"
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>

            <Typography variant="body1" gutterBottom sx={{ mt: 2 }}>
                <Link target="_blank" href={t("blood-test-preparation-url")}>
                    {t("Подготовка пациента к анализу крови Тераностика старения")}.
                </Link>
            </Typography>

            <NextStepButton to="/questions/" />

            <Divider sx={{ mt: 4 }} />
                <Box sx={{ mt: 4, display: "flex", flexFlow: "row wrap", gap: 4, justifyContent:'center' }}>
                    <Link target="_blank" href={t('privacy-policy-url')} sx={{ color: "grey", textDecoration: "none" }}>{t('privacy-policy')}</Link>
                    <Link target="_blank" href={t('user-agreement-url')} sx={{ color: "grey", textDecoration: "none" }}>{t('user-agreement')}</Link>
                </Box>

            <StepInfoBlock text={ help.texts['labs-footer-'+i18n.language] } />
        </Container>
    );
}
